import { useMutation, useQueryClient } from "@tanstack/react-query"

import {
  usePaginatedResource,
  useResourceItem,
} from "./useCrudResource"
import {
  getVehicleImporterBankAccounts,
  getVehicleImporterBankAccount,
  createVehicleImporterBankAccount,
  updateVehicleImporterBankAccount,
  deleteVehicleImporterBankAccount,
  setDefaultVehicleImporterBankAccount,
} from "api/vehicleImporterBankAccountApi"

export const VEHICLE_IMPORTER_BANK_ACCOUNT_QUERY_KEY =
  "vehicle-importer-bank-account"

const scopedKey = importerId =>
  `${VEHICLE_IMPORTER_BANK_ACCOUNT_QUERY_KEY}-${importerId}`

export const useVehicleImporterBankAccounts = (
  importerId,
  params = {},
  enabled = true
) =>
  usePaginatedResource(
    scopedKey(importerId),
    qs => getVehicleImporterBankAccounts(importerId, qs),
    params,
    enabled && !!importerId
  )

export const useVehicleImporterBankAccount = (importerId, id, enabled = true) =>
  useResourceItem(
    scopedKey(importerId),
    qid => getVehicleImporterBankAccount(importerId, qid),
    id,
    enabled && !!importerId && !!id
  )

export const useCreateVehicleImporterBankAccount = importerId => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: payload => createVehicleImporterBankAccount({ importerId, ...payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scopedKey(importerId)] })
      queryClient.invalidateQueries({ queryKey: ["vehicleImporters"] })
    },
  })
}

export const useEditVehicleImporterBankAccount = importerId => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: payload => updateVehicleImporterBankAccount({ importerId, ...payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scopedKey(importerId)] })
      queryClient.invalidateQueries({ queryKey: ["vehicleImporters"] })
    },
  })
}

export const useDeleteVehicleImporterBankAccount = importerId => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: id => deleteVehicleImporterBankAccount(importerId, id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scopedKey(importerId)] })
      queryClient.invalidateQueries({ queryKey: ["vehicleImporters"] })
    },
  })
}

export const useSetDefaultVehicleImporterBankAccount = importerId => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: id => setDefaultVehicleImporterBankAccount(importerId, id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scopedKey(importerId)] })
      queryClient.invalidateQueries({ queryKey: ["vehicleImporters"] })
    },
  })
}
